import {Button} from "@mui/material";

// The app's primary filled action button. A thin wrapper over MUI Button so every
// call site gets consistent brand styling, ripple, keyboard focus and disabled
// semantics from a single place. Uses the mode-independent brand action color
// (crust brown + cream text) so it reads the same in light and dark.
//
// `type` defaults to "button"; pass type="submit" for the button that submits a form.
export default function FilledButton({children, onClick, style = {}, disabled = false, color, type = "button"}) {
    return (
        <Button
            type={type}
            variant="contained"
            onClick={onClick}
            disabled={disabled}
            style={style}
            sx={(theme) => ({
                gap: '0.5em',
                backgroundColor: color || theme.brand.actionButton.bg,
                color: theme.brand.actionButton.text,
                '&:hover': {backgroundColor: color || theme.brand.actionButton.hover},
                '&.Mui-disabled': {
                    backgroundColor: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabled,
                },
            })}
        >
            {children}
        </Button>
    );
}
